import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tips[matIcon][bgColor]',
  imports: [CommonModule, MatIconModule],
  templateUrl: './tips.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tips.component.scss'],
})
export class TipsComponent implements OnInit {
  @Input() matIcon: string = 'info';
  @Input() bgColor: string = 'rgb(27, 117, 208)';
  @Input() txtColor: string = 'white';
  @Input() matIconColor: string = 'white';

  constructor() {}

  ngOnInit(): void {}
}
